<div class="safe-send-container" [ngClass]="{ submitted: isSubmitted }">
  <div class="safe-send-header">
    <ds-icon name="unlock"></ds-icon>
    <span class="header-text">{{ safeSendTitle }}</span>
  </div>
  <div class="content">
    <p *ngIf="safeSendDescription" class="safe-send-description">
      <ds-icon
        *ngIf="isSubmitted"
        name="check-circle"
        color="green"
        class="check-icon"
      ></ds-icon>
      {{ safeSendDescription }}
    </p>

    <ucx-form-fields
      *ngIf="formFields?.length && !isSubmitted"
      [formFields]="formFields"
      [okBtnText]="submitText"
      [cancelBtnText]="skipText"
      [isCancelBtnHidden]="isCancelBtnHidden"
      [creditCardConfig]="creditCardConfig"
      [onHandleSubmit]="onSubmit"
      [onHandleCancel]="oncancel"
    ></ucx-form-fields>
  </div>
</div>
